<template>
  <section>
    <div v-if="obtenerSonGlobosVisibles" id="balloon-container"></div>
    <div class="ma-0 pa-0">
      <v-row justify="center" class="ma-0 pa-0 pt-5">
        <v-col cols="4" xs="4" sm="4" md="3" lg="3" xl="3" class="ma-0 pa-0">
          <v-img :src="ObtenerImgTerminacion"></v-img>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col cols="10" class="ma-0 pa-0">
          <h2 class="texto-titulo text-center font-weight-bold">
            Tu solicitud ha sido registrada con éxito!
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col cols="10" class="ma-0 pa-0">
          <p class="text-body text-center grey--text text--darken-2">
            <span class="text-subtitle font-weight-bold black--text"
              >Estamos validando tus datos,</span
            >
            y en menos de
            <span class="text-subtitle font-weight-bold black--text"
              >24 horas</span
            >
            recibirás respuesta de tu solicitud.
          </p>
          <p
            class="
              text-body text-center
              black--text
              text-decoration-underline
              font-weight-bold
            "
          >
            Te notificaremos vía SMS y/o correo eletrónico los siguientes pasos
          </p>
          <!-- <p class="text-body text-center grey--text text--darken-2">
            ¿Dudas y/o aclaraciones? Llama sin costo al
            <a href="tel:8003000268">800 3000 268</a>
          </p> -->
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0">
        <v-col
          cols="10"
          class="ma-0 pa-0 d-flex flex-column justify-center align-center"
        >
          <v-btn
            fab
            dark
            color="primary"
            class="mb-1"
            download="Comprobante_Solicitud_Credito.png"
            :href="urlComprobante"
          >
            <v-icon dark>mdi-download</v-icon>
          </v-btn>
          <p class="text-body-2 text-center font-weight-medium">
            Descargar comprobante de solicitud de crédito
          </p>
        </v-col>
      </v-row>
      <!-- <v-row justify="center">
        <v-col
          cols="8"
          xs="8"
          sm="8"
          md="12"
          lg="12"
          xl="12"
          class="d-flex flex-row justify-center"
        > -->
      <!-- <v-btn color="primary" href="https://www.cajamorelia.com.mx/">
            Ir a página de Caja Morelia Valladolid</v-btn
          > -->
      <!-- <v-btn color="primary" @click="irStatus">
            Revisar estatus solicitud</v-btn
          > -->
      <!-- </v-col>
      </v-row> -->
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-7 mb-2 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <p class="text-center grey--text text--darken-2 ma-0">
            ¿Dudas sobre el registro de tu solicitud? Contáctanos via Whatsapp o
            al telefono
          </p>
          <!--<a href="tel:8003000268" style="color: lightgreen"
              ><br />
              800-3000-268</a
            >
             <br />800-3000-268<br /> -->
          <!-- <router-link
            :to="{ name: 'cancelacion' }"
            class="text-body-30 font-weight-bold"
            >Haz click aqui</router-link
          > 
          </p>-->
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-0 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="4" class="ma-0 pa-0">
          <v-btn
            class="align-self-center"
            color="primary"
            v-bind="attrs"
            v-on="on"
            elevation="3"
            @click="whats"
            >Mensaje<v-icon right light>mdi-whatsapp</v-icon></v-btn
          >
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="4" class="ma-0 pa-0">
          <v-btn
            class="align-self-center"
            color="primary"
            v-bind="attrs"
            v-on="on"
            elevation="3"
            @click="llamar"
            >Llamar<v-icon right light>mdi-phone</v-icon></v-btn
          >
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-2">
        <v-col cols="8" class="ma-0 pa-0 mb-5">
          <br />
          <p class="text-center grey--text text--darken-2 ma-0 pa-0">
            Tu información está segura: Puedes cerrar esta ventana en cualquier
            momento.
          </p>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  name: 'Terminacion',
  mixins: [InsertaLogMixin],
  data: () => ({
    mostrarGlobos: true,
    duracionSegundosGlobos: 2,
    urlComprobante: '',
  }),
  computed: {
    ObtenerImgTerminacion() {
      // return require(this.urlImgTerminacion)
      return require('@/assets/images/terminacion.png')
    },
    ...mapGetters({
      obtenerSonGlobosVisibles: 'utilidades/obtenerSonGlobosVisibles',
    }),
  },
  methods: {
    whats() {
      // window.location.href = 'https://wa.me/5215510695948'
      window.open('https://wa.me/5215510695948', '_blank')
    },
    llamar() {
      // window.location.href = 'tel:8003000268'
      window.open('tel:8003000268', '_blank')
    },
    irStatus() {
      // console.log('e')
      this.$store.dispatch('credito/establecerStatusSol', {
        id_status: 2,
        id_sub_status: 1,
        banca_activa: 1,
      })
      this.$router.push(
        '/?folio=' + this.$store.getters['credito/obtenerFolioDigital']
      )
      // location.reload()
    },
    random(num) {
      return Math.floor(Math.random() * num)
    },
    getRandomStyles() {
      const estilosRandom = Math.floor(Math.random() * 5)
      var mt = this.random(200)
      var ml = this.random(50)
      var dur = this.duracionSegundosGlobos
      const estilosGlobos = [
        {
          r: '62',
          g: '147',
          b: '235',
        },
        {
          r: '235',
          g: '215',
          b: '62',
        },
        {
          r: '148',
          g: '36',
          b: '202',
        },
        {
          r: '244',
          g: '67',
          b: '54',
        },
        {
          r: '31',
          g: '208',
          b: '131',
        },
      ]
      return `
      background-color: rgba(${estilosGlobos[estilosRandom].r},${
        estilosGlobos[estilosRandom].g
      },${estilosGlobos[estilosRandom].b},0.8); 
      color: rgba(${estilosGlobos[estilosRandom].r},${
        estilosGlobos[estilosRandom].g
      },${estilosGlobos[estilosRandom].b},0.8);
      box-shadow: inset -7px -3px 10px rgba(${
        estilosGlobos[estilosRandom].r - 10
      },${estilosGlobos[estilosRandom].g - 10},${
        estilosGlobos[estilosRandom].b - 10
      },0.7);
      margin: ${mt}px 0 0 ${ml}px;
      animation: float ${dur}s ease-in
      `
    },
    descargaComprobante() {
      this.$gtag.event('descargaComprobante', {
        event_category: 'change_in_window',
        event_label: 'Se descargo el comrobante',
        value: 1,
      })
      this.InsertaLog({ notas: 'Se descargo el comrobante' })
      window.open(this.urlComprobante)
    },
    createBalloons(num) {
      var balloonContainer = document.getElementById('balloon-container')
      for (var i = num; i > 0; i--) {
        var balloon = document.createElement('div')
        balloon.className = 'balloon'
        balloon.style.cssText = this.getRandomStyles()
        balloonContainer.append(balloon)
      }
    },
  },
  mounted() {
    this.InsertaLog()
    if (this.obtenerSonGlobosVisibles) {
      this.createBalloons(7)
    }
    setTimeout(() => {
      this.mostrarGlobos = false
      this.$store.commit('utilidades/desabilitarGlobos')
    }, this.duracionSegundosGlobos * 1000)
    setTimeout(() => {
      this.$router.push('/avanceCredito')
    }, 20 * 1000)
  },
  created() {
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
    this.urlComprobante =
      'data:image/png;base64,' +
      this.$store.getters['personaDocumentos/obtenerComprobanteBase64']
  },
}
</script>

<style>
.img-terminacion {
  width: 100px;
  height: 100px;
}
body {
  margin: 0;
}

#balloon-container {
  height: 100vh;
  padding: 1em;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  background: transparent;
  position: absolute;
}

.balloon {
  height: 125px;
  width: 105px;
  border-radius: 75% 75% 70% 70%;
  position: relative;
  z-index: 1000;
}

.balloon:before {
  content: '';
  height: px;
  width: 1px;
  padding: 1px;
  background-color: #c9c9c9;
  display: block;
  position: absolute;
  top: 125px;
  left: 0;
  right: 0;
  margin: auto;
}

.balloon:after {
  content: '▲';
  text-align: center;
  display: block;
  position: absolute;
  color: inherit;
  top: 120px;
  left: 0;
  right: 0;
  margin: auto;
}

@keyframes float {
  from {
    transform: translateY(100vh);
    opacity: 1;
  }
  to {
    transform: translateY(-300vh);
    opacity: 0.8;
  }
}
</style>
